// Federal Register SDK
export * from './api/client';

// Generated API exports
export * from './api/generated/endpoints';
export * from './api/generated/model';

export default {
  name: 'Federal Register SDK',
  version: '0.1.0',
  description: 'TypeScript SDK and MCP server for the Federal Register API',
};
